// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Star Trek Universe - Star Systems Configuration
 */

export const starSystems = [
  {
    id: 1900,
    name: 'Earth (Sol III)',
    type: 'planet',
    distance: 0,
    coordinates: { x: 45, y: 50, z: 0 },
    threat: 'SAFE',
    resources: 'HIGH',
    services: ['refuel', 'exploration', 'repairs', 'trade', 'weapons', 'upgrades', 'modules'],
    tradeType: 'station_advanced',
    primaryColor: '#3b82f6',
    secondaryColor: '#60a5fa',
    hasRings: false,
    description: 'Homeworld of humanity. United Federation of Planets headquarters. Starfleet Command.',
    scanDescription: 'Class M planet. Advanced civilization. Starfleet Academy. Federation capital. To boldly go...'
  },
  {
    id: 1901,
    name: 'Vulcan',
    type: 'planet',
    distance: 16,
    coordinates: { x: 60, y: 58, z: 5 },
    threat: 'LOW',
    resources: 'HIGH',
    services: ['refuel', 'exploration', 'repairs', 'trade', 'upgrades'],
    tradeType: 'luxury',
    primaryColor: '#dc2626',
    secondaryColor: '#f97316',
    hasRings: false,
    description: 'Desert planet. Homeworld of Vulcans. Logic and reason prevail. Live long and prosper.',
    scanDescription: 'Class M planet. Arid climate. Vulcan Science Academy. Logic-based civilization. Fascinating.'
  },
  {
    id: 1902,
    name: 'Qo\'noS (Kronos)',
    type: 'planet',
    distance: 22,
    coordinates: { x: 30, y: 42, z: -8 },
    threat: 'HIGH',
    resources: 'MEDIUM',
    services: ['refuel', 'exploration', 'weapons', 'trade'],
    tradeType: 'industrial',
    primaryColor: '#7f1d1d',
    secondaryColor: '#991b1b',
    hasRings: false,
    description: 'Homeworld of the Klingon Empire. Warrior culture. Honor and glory. Qapla\'!',
    scanDescription: 'Class M planet. Klingon High Council. Warrior society. Blood wine flows. Today is a good day to die.'
  },
  {
    id: 1903,
    name: 'Romulus',
    type: 'planet',
    distance: 28,
    coordinates: { x: 65, y: 45, z: -10 },
    threat: 'EXTREME',
    resources: 'MEDIUM',
    services: ['refuel', 'exploration', 'trade'],
    tradeType: 'industrial',
    primaryColor: '#166534',
    secondaryColor: '#16a34a',
    hasRings: false,
    description: 'Homeworld of the Romulan Star Empire. Secretive and cunning. Beware the Tal Shiar.',
    scanDescription: 'Class M planet. Romulan Senate. Cloaking technology. Espionage detected. Trust no one.'
  },
  {
    id: 1904,
    name: 'Andoria',
    type: 'planet',
    distance: 18,
    coordinates: { x: 52, y: 65, z: 8 },
    threat: 'LOW',
    resources: 'HIGH',
    services: ['refuel', 'exploration', 'repairs', 'trade'],
    tradeType: 'mining',
    primaryColor: '#0ea5e9',
    secondaryColor: '#38bdf8',
    hasRings: false,
    description: 'Ice planet. Homeworld of Andorians. Blue-skinned warriors. Federation founding member.',
    scanDescription: 'Class P planet. Sub-zero temperatures. Andorian Imperial Guard. Mining operations. Antennae detected.'
  },
  {
    id: 1905,
    name: 'Ferenginar',
    type: 'planet',
    distance: 25,
    coordinates: { x: 38, y: 60, z: -5 },
    threat: 'MODERATE',
    resources: 'HIGH',
    services: ['refuel', 'exploration', 'trade', 'weapons', 'upgrades'],
    tradeType: 'luxury',
    primaryColor: '#f59e0b',
    secondaryColor: '#fbbf24',
    hasRings: false,
    description: 'Homeworld of the Ferengi Alliance. Constant rain. Profit is everything. Greed is eternal.',
    scanDescription: 'Class M planet. Perpetual precipitation. Ferengi Commerce Authority. Gold-pressed latinum detected.'
  },
  {
    id: 1906,
    name: 'Bajor',
    type: 'planet',
    distance: 20,
    coordinates: { x: 48, y: 35, z: 3 },
    threat: 'MODERATE',
    resources: 'MEDIUM',
    services: ['refuel', 'exploration', 'repairs', 'trade'],
    tradeType: 'agricultural',
    primaryColor: '#8b5cf6',
    secondaryColor: '#a78bfa',
    hasRings: false,
    description: 'Spiritual world. Recovering from Cardassian occupation. The Prophets watch over.',
    scanDescription: 'Class M planet. Bajoran religion. Orb of the Prophets. Deep Space Nine nearby. The Emissary has been here.'
  },
  {
    id: 1907,
    name: 'Cardassia Prime',
    type: 'planet',
    distance: 30,
    coordinates: { x: 28, y: 55, z: 10 },
    threat: 'HIGH',
    resources: 'MEDIUM',
    services: ['refuel', 'exploration', 'weapons', 'trade'],
    tradeType: 'industrial',
    primaryColor: '#78716c',
    secondaryColor: '#a8a29e',
    hasRings: false,
    description: 'Homeworld of Cardassian Union. Military dictatorship. Obsidian Order operates in shadows.',
    scanDescription: 'Class M planet. Cardassian Central Command. Authoritarian regime. Surveillance detected. Proceed with caution.'
  },
  {
    id: 1908,
    name: 'Betazed',
    type: 'planet',
    distance: 15,
    coordinates: { x: 55, y: 48, z: -3 },
    threat: 'LOW',
    resources: 'HIGH',
    services: ['refuel', 'exploration', 'repairs', 'trade'],
    tradeType: 'luxury',
    primaryColor: '#ec4899',
    secondaryColor: '#f9a8d4',
    hasRings: false,
    description: 'Homeworld of Betazoids. Telepathic species. Beautiful paradise world. Counselor Troi\'s home.',
    scanDescription: 'Class M planet. Telepathic civilization. Peaceful culture. Your thoughts are not private here.'
  },
  {
    id: 1909,
    name: 'Risa',
    type: 'planet',
    distance: 32,
    coordinates: { x: 70, y: 52, z: -12 },
    threat: 'SAFE',
    resources: 'LUXURY',
    services: ['refuel', 'exploration', 'repairs', 'trade'],
    tradeType: 'luxury',
    primaryColor: '#22c55e',
    secondaryColor: '#86efac',
    hasRings: false,
    description: 'Pleasure planet. Tropical paradise. Shore leave destination. All that is ours is yours.',
    scanDescription: 'Class M planet. Resort world. Perfect weather control. Jamaharon available. Relaxation protocols engaged.'
  },
  {
    id: 1910,
    name: 'Deep Space Nine',
    type: 'station',
    distance: 21,
    coordinates: { x: 42, y: 68, z: 6 },
    threat: 'MODERATE',
    resources: 'GATEWAY',
    services: ['refuel', 'repairs', 'trade', 'weapons', 'upgrades', 'modules'],
    tradeType: 'station_advanced',
    primaryColor: '#6b7280',
    secondaryColor: '#9ca3af',
    hasRings: false,
    description: 'Cardassian-built station. Guards the Bajoran wormhole. Gateway to Gamma Quadrant.',
    scanDescription: 'Terok Nor class station. Wormhole access. Quark\'s Bar. Promenade. The Sisko commands here.'
  },
  {
    id: 1911,
    name: 'Borg Cube Wreckage',
    type: 'station',
    distance: 35,
    coordinates: { x: 25, y: 40, z: -15 },
    threat: 'EXTREME',
    resources: 'BORG TECHNOLOGY',
    services: ['refuel'],
    tradeType: 'remote',
    primaryColor: '#1f2937',
    secondaryColor: '#4ade80',
    hasRings: false,
    description: 'Destroyed Borg cube. Dangerous salvage. Nanoprobes still active. Resistance was not futile.',
    scanDescription: 'Borg debris field. Extreme danger. Assimilation risk. Nanoprobes detected. Do not approach without shields.'
  }
];

export const starPositions = starSystems.reduce((acc, system) => {
  acc[system.id] = system.coordinates;
  return acc;
}, {});

const startrekSystems = { starSystems, starPositions };
export default startrekSystems;
